// 体験談カセットの章アンカー付き「続きをみる」リンクのクリック横取りを実装する共通モジュール (#10592)
//
// desktop/mobile の Stimulus コントローラから attachLinkInterceptor を呼ぶことで使用する。
// 片方だけ修正される silent drift を防ぐため、ロジックを1箇所に集約している。
//
// 役割:
// - カセットリンク（hash 付き URL）のクリックを横取り
// - hash を sessionStorage に保存し、hash なし URL で遷移
// - これによりブラウザのネイティブhashジャンプ（対象章チラ見）を回避
// - 遷移先 experiences_anchor_scroll.js が sessionStorage を読んでスクロール実行
//
// ⚠️ INTENT_STORAGE_KEY は experiences_anchor_scroll.js の同名定数と同期必須。
//    変更時は両方を更新すること（sync spec で自動検知）。

// カセット側と遷移先で sessionStorage 経由で intent を受け渡すためのキー。
export const INTENT_STORAGE_KEY = 'experiencesAnchorIntent'

// 体験談詳細ページへのリンクのみを横取り対象にするための pathname パターン。
// wrapper 内の他の hash 付きリンク（CTA 等）を誤って拾わないためのガード。
const EXPERIENCE_DETAIL_PATH_REGEXP = /\/move_(in|out)_experiences\//

// カセット要素にクリックインターセプタを設置する。
// 戻り値: 解除関数（Stimulus の disconnect() で呼ぶこと）。
export function attachLinkInterceptor (element) {
  const handler = handleClick
  element.addEventListener('click', handler)
  return () => element.removeEventListener('click', handler)
}

function handleClick (event) {
  // 修飾キー・ミドルクリック等は既定動作（新タブ/新ウィンドウ等で開く）に委ねる。
  // これらを横取りすると「Cmd+Click で新タブが開かない」等のUXバグになる。
  // 新タブで開いた場合はそもそも sessionStorage がタブ間で共有されないため、
  // ブラウザのネイティブhash遷移に任せる方が正しい挙動。
  if (event.defaultPrevented) return
  if (event.button !== 0) return
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

  const link = event.target.closest('a')
  if (!link || !link.hash) return
  // target="_blank" 等の明示的な別タブ/別ウィンドウ指定も既定動作に委ねる
  if (link.target && link.target !== '' && link.target !== '_self') return
  if (!EXPERIENCE_DETAIL_PATH_REGEXP.test(link.pathname)) return

  try {
    sessionStorage.setItem(
      INTENT_STORAGE_KEY,
      JSON.stringify({ hash: link.hash, timestamp: Date.now() }),
    )
  } catch {
    // sessionStorage 無効時（プライベートブラウズ厳格モード等）は何もせず、
    // ブラウザのネイティブhash遷移に委ねる（progressive enhancement）。
    // preventDefault を呼んでいないため、ブラウザが link.href へ遷移を継続する。
    return
  }

  // storage 保存成功後にのみ既定遷移を止めて hash なしURLへ遷移する。
  // これによりブラウザのネイティブhashジャンプが発生せず、
  // ユーザーは「対象章が一瞬見える」ことなくページトップに着地する。
  event.preventDefault()
  window.location.href = link.pathname + link.search
}
